import {Dispatch} from "redux";
import {FastmenuAction, FastmenuActionTypes} from "../../types/fastmenu";
import {
    addFavoriteFasterMenus,
    deleteFavoriteFasterMenus, FasterMenuType,
    getFavoriteAll,
    updateFasterMenus
} from "../../../services/FasterMenus";

export const getFastmenuData = () => {
    return (dispatch: Dispatch<FastmenuAction>) => {
        return new Promise(() => {
            dispatch({ type: FastmenuActionTypes.GET_FASTMENU_REQUEST })
            getFavoriteAll()
                    .then(response => {
                        dispatch({
                            payload: {
                                result: response,
                            },
                            type: FastmenuActionTypes.GET_FASTMENU_SUCCESS,
                        })
                    })
                    .catch((error: any) => {
                        dispatch({
                            error: {
                                result: error.response,
                            },
                            type: FastmenuActionTypes.GET_FASTMENU_ERROR,
                        })
                    })
        })
    }
}

export const updateFastmenuData = (payload: any) => {

    const { trnType, index } = payload;
    return (dispatch: Dispatch<FastmenuAction>) => {
        return new Promise(() => {
            dispatch({ type: FastmenuActionTypes.UPDATE_FASTMENU_REQUEST })
            updateFasterMenus(trnType, index)
                .then(response => {

                    dispatch({
                        payload: {
                            result: response,
                        },
                        type: FastmenuActionTypes.UPDATE_FASTMENU_SUCCESS,
                    })
                })
                .catch((error: any) => {
                    dispatch({
                        error: {
                            result: [],
                        },
                        type: FastmenuActionTypes.UPDATE_FASTMENU_ERROR,
                    })
                })
        })
    }
}

export const addFavoriteFastmenuData = (payload: any) => {
    const { trnType , checked , fastMenuList } = payload;
    return (dispatch: Dispatch<FastmenuAction>) => {
        return new Promise(() => {
            dispatch({ type: FastmenuActionTypes.ADD_FAVORITE_FASTMENU_REQUEST })
            if(checked) {
                addFavoriteFasterMenus(trnType)
                    .then(response => {
                        var index = fastMenuList.findIndex((row:FasterMenuType)=>
                            row.trnType===trnType

                        )
                        if(index !== undefined && index !== null){
                            fastMenuList[index].isInFavoriteList = checked
                        }
                        dispatch({
                            payload: {
                                result: fastMenuList,
                            },
                            type: FastmenuActionTypes.ADD_FAVORITE_FASTMENU_SUCCESS,
                        })
                    })
                    .catch((error: any) => {
                        dispatch({
                            error: {
                                result: error.response,
                            },
                            type: FastmenuActionTypes.ADD_FAVORITE_FASTMENU_ERROR,
                        })
                    })
            } else {
                deleteFavoriteFasterMenus(trnType)
                    .then(response => {
                        var index = fastMenuList.findIndex((row:FasterMenuType)=>
                            row.trnType===trnType

                        )
                        if(index !== undefined && index !== null){
                            fastMenuList[index].isInFavoriteList = checked
                        }
                        dispatch({
                            payload: {
                                result: fastMenuList,
                            },
                            type: FastmenuActionTypes.ADD_FAVORITE_FASTMENU_SUCCESS,
                        })
                    })
                    .catch((error: any) => {
                        dispatch({
                            error: {
                                result: error.response,
                            },
                            type: FastmenuActionTypes.ADD_FAVORITE_FASTMENU_ERROR,
                        })
                    })
            }
        })
    }
}
